<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>类目管理</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <el-card shadow="hover">
            <!--  -->
            <el-form :inline="true" size="small" v-model="listQuery">
                <el-form-item>
                    <el-button icon="el-icon-plus" type="primary" plan @click="addCategoryRoot">新增根类目</el-button>
                </el-form-item>
            </el-form>

            <!-- 列表数据  default-expand-all -->
            <el-table :data="listData" border style="width: 100%" row-key="id" fit :tree-props="{children:'childCategorys'}">
                <el-table-column prop="id" label="类目ID" width="120px" fixed="left" :indent="40"></el-table-column>

                <el-table-column prop="categoryName" label="类目名称"></el-table-column>
                <el-table-column prop="categoryDesc" label="类目描述"></el-table-column>

                <el-table-column prop="level" label="类目级别"></el-table-column>
                <el-table-column prop="remark" label="备注"></el-table-column>
                <el-table-column prop="createTime" label="创建时间" :formatter="dateFormatA" width="140px"></el-table-column>
                <el-table-column prop="updateTime" label="更新时间" :formatter="dateFormatA" width="140px"></el-table-column>

                <el-table-column prop label="操作" fixed="right" width="280px" align="center">
                    <template slot-scope="scope">
                        <!-- <el-button type="text" @click="shipmentDetail(scope.row,scope.$index)" size="mini">编辑子类目</el-button> -->
                        <el-button icon="el-icon-plus" type="text" size="mini" @click="() => append(scope.row)" v-if="scope.row.level==1||scope.row.level==2">添加子类目</el-button>
                        <el-button type="text" @click="propertyDetail(scope.row)" icon="el-icon-link" size="mini" v-if="scope.row.level==3">属性详情</el-button>
                        <el-button type="text" @click="delCategory(scope.row)" icon="el-icon-delete" size="mini" class="red">删除</el-button>
                        <el-button type="text" @click="editCategory(scope.row)" icon="el-icon-edit" size="mini">编辑</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>

        <!-- 编辑子类目 -->

        <el-dialog :title="editCategoryTree" :visible.sync="editCategoryVisible" width="600px" center>
            <el-form ref="editCategoryForm" :model="editCategoryForm" label-width="100px">
                <div>
                    <el-tree :data="treedata" node-key="id" default-expand-all :expand-on-click-node="false" :props="treeProps">
                        <span class="custom-tree-node" slot-scope="{ node, data }">
                            <span>{{ node.label }}</span>
                            <span>
                                <el-button icon="el-icon-plus" type="text" size="mini" @click="() => append(data)" v-if="data.level==1||data.level==2">添加子类目</el-button>
                                <el-button v-if="data.level==2||data.level==3" type="text" size="mini" class="red" icon="el-icon-delete" @click="() => remove(node, data)">删除此类目</el-button>
                                <el-button v-if="data.level==2||data.level==3" type="text" size="mini" icon="el-icon-edit" @click="() => update(node, data)">编辑此类目</el-button>
                            </span>
                        </span>
                    </el-tree>
                </div>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editCategoryVisible = false">关 闭</el-button>
            </span>
        </el-dialog>

        <!-- 新增类目 -->

        <el-dialog title="新增类目" :visible.sync="addVisable" width="600px" :close-on-click-modal="false" center>
            <el-form ref="addCategoryForm" :rules="addRules" label-width="100px" :model="addCategoryForm" size="medium">
                <el-row>
                    <el-form-item label="类目级别" prop="level">
                        <el-input v-model="addCategoryForm.level" clearable placeholder="请输入类目级别" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="类目名称" prop="categoryName">
                        <el-input v-model="addCategoryForm.categoryName" clearable placeholder="请输入类目名称"></el-input>
                    </el-form-item>
                    <el-form-item label="类目描述" prop="categoryDesc">
                        <el-input v-model="addCategoryForm.categoryDesc" clearable placeholder="请输入类目名称"></el-input>
                    </el-form-item>
                    <el-form-item label="备注" prop="remark">
                        <el-input type="textarea" style="width:400px" :rows="3" placeholder="请输入备注" v-model="addCategoryForm.remark"></el-input>
                    </el-form-item>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click=" addVisable= false">取 消</el-button>
                <el-button type="primary" @click=" confirmAdd()">确定</el-button>
            </span>
        </el-dialog>

        <!-- 编辑类目 -->

        <el-dialog title="编辑类目" :visible.sync="editVisable" width="600px" :close-on-click-modal="false" center>
            <el-form ref="editCategoryForm" :rules="editRules" label-width="100px" :model="editCategoryForm" size="medium">
                <el-row>
                    <el-form-item label="类目级别" prop="level">
                        <el-input v-model="editCategoryForm.level" clearable placeholder="请输入类目级别" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="类目名称" prop="categoryName">
                        <el-input v-model="editCategoryForm.categoryName" clearable placeholder="请输入类目名称"></el-input>
                    </el-form-item>
                    <el-form-item label="类目描述" prop="categoryDesc">
                        <el-input v-model="editCategoryForm.categoryDesc" clearable placeholder="请输入类目名称"></el-input>
                    </el-form-item>
                    <el-form-item label="备注" prop="remark">
                        <el-input type="textarea" style="width:400px" :rows="3" placeholder="请输入备注" v-model="editCategoryForm.remark"></el-input>
                    </el-form-item>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click=" editVisable= false">取 消</el-button>
                <el-button @click=" confirmEdit()">确定</el-button>
            </span>
        </el-dialog>

        <!-- 属性详情 -->

        <el-dialog title="属性绑定详情" :visible.sync="detailVisable" width="1000px" :close-on-click-modal="false" center>
            <div style="margin:10px;">
                <el-row>
                    <el-button icon="el-icon-plus" type="primary" plan @click="addPropertyBind">绑定新属性</el-button>
                </el-row>
            </div>
            <el-table :data="propertyBindList" border style="width: 100%" class="table" fit>
                <el-table-column prop="attributeId" label="属性ID" fixed="left"></el-table-column>
                <el-table-column prop="propertyName" label="属性名称"></el-table-column>
                <el-table-column prop="propertyDesc" label="属性描述"></el-table-column>
                <el-table-column prop="inputScope" label="属性范围"></el-table-column>
                <!-- <el-table-column prop="propertyValue" label="属性值"></el-table-column> -->
                <!-- <el-table-column prop="bindType" label="绑定类型">
              <template slot-scope="scope">
            <span v-if="scope.row.bindType==1">绑定到类目</span>
            <span v-if="scope.row.bindType==2">绑定到商品spu</span>
          </template>
        </el-table-column>-->
                <el-table-column prop="isNess" label="是否必填">
                    <template slot-scope="scope">
                        <span v-if="scope.row.isNess">是</span>
                        <span v-if="scope.row.isNess==false">否</span>
                    </template>
                </el-table-column>
                <el-table-column prop="multipleChoice" label="是否可多选">
                    <template slot-scope="scope">
                        <span v-if="scope.row.multipleChoice==1">是</span>
                        <span v-if="scope.row.multipleChoice===0">否</span>
                    </template>
                </el-table-column>
                <el-table-column prop="status" label="输入方式">
                    <template slot-scope="scope">
                        <span v-if="scope.row.inputType==0">输入</span>
                        <span v-if="scope.row.inputType==1">选择</span>
                    </template>
                </el-table-column>
                <el-table-column prop="otherId" label="被绑定id"></el-table-column>
                <el-table-column prop label="操作" fixed="right" width="200px" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" @click="delProperty(scope.row)" icon="el-icon-delete" size="mini" class="red">删除</el-button>
                        <el-button type="text" @click="editProperty(scope.row)" icon="el-icon-edit" size="mini">编辑</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <span slot="footer" class="dialog-footer">
                <el-button @click=" detailVisable=false" type="primary">关闭</el-button>
            </span>
        </el-dialog>
        <!-- 绑定新属性 -->
        <el-dialog title="绑定新属性" :visible.sync="addPropertyVisable" width="500px" :close-on-click-modal="false" center>
            <el-form ref="addPropertyForm" :rules="addPropertyRules" label-width="100px" :model="addPropertyForm" size="medium">
                <el-row>
                    <el-form-item label="属性" prop="propertyId">
                        <el-select v-model="addPropertyForm.propertyId" clearable placeholder="请选择属性" filterable @change="propertyChange1">
                            <el-option v-for="(item,index) in propertyList" :key="index" :label="item.propertyName" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="是否必填" prop="isNess">
                        <el-select v-model="addPropertyForm.isNess" clearable placeholder="请选择">
                            <el-option label="是" :value="true"></el-option>
                            <el-option label="否" :value="false"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="是否可多选" prop="multipleChoice" v-if="addPropertyForm.inputType==1">
                        <el-select v-model="addPropertyForm.multipleChoice" clearable placeholder="请选择">
                            <el-option label="是" :value="1"></el-option>
                            <el-option label="否" :value="0"></el-option>
                        </el-select>
                    </el-form-item>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click=" addPropertyVisable= false">取 消</el-button>
                <el-button @click=" confirmAddProperty()">确定</el-button>
            </span>
        </el-dialog>

        <!-- 编辑属性 -->
        <el-dialog title="编辑属性" :visible.sync="editPropertyVisable" width="500px" :close-on-click-modal="false" center @change="propertyChange2">
            <el-form ref="editPropertyForm" :rules="editPropertyRules" label-width="100px" :model="editPropertyForm" size="medium">
                <el-row>
                    <el-form-item label="属性" prop="propertyId">
                        <el-select v-model="editPropertyForm.propertyId" clearable placeholder="请选择属性" filterable>
                            <el-option v-for="(item,index) in propertyList" :key="index" :label="item.propertyName" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="是否必填" prop="isNess">
                        <el-select v-model="editPropertyForm.isNess" clearable placeholder="请选择">
                            <el-option label="是" :value="true"></el-option>
                            <el-option label="否" :value="false"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="是否可多选" prop="multipleChoice" v-if="editPropertyForm.inputType==1">
                        <el-select v-model="editPropertyForm.multipleChoice" clearable placeholder="请选择">
                            <el-option label="是" :value="1"></el-option>
                            <el-option label="否" :value="0"></el-option>
                        </el-select>
                    </el-form-item>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click=" editPropertyVisable= false">取 消</el-button>
                <el-button @click=" confirmEditProperty()">确定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import moment from "moment";
import Pagination from "../common/Pagination";
import wmsApi from "@/script/api/wmsApi";
import globalData from "@/components/common/globaldata/global.data.vue";
import "./css/index.css";
export default {
    components: { Pagination },
    filters: {},
    data() {
        return {
            listData: [],
            total: 0,
            pageSize: 10,
            currentPage: 1, //当前页
            listQuery: {},
            treeIndex: "",
            editCategoryTree: "",
            editCategoryVisible: false,
            editCategoryForm: {},
            treedata: [],
            treeProps: {
                label: "categoryName",
                children: "childCategorys",
            },
            addVisable: false,
            addCategoryForm: {
                level: "",
                parentId: "",
                categoryName: "",
                categoryDesc: "",
                remark: "",
            },
            addRules: {
                level: [
                    {
                        required: true,
                        message: "请输入类目级别",
                        trigger: "change",
                    },
                ],
                categoryName: [
                    {
                        required: true,
                        message: "请输入类目名称",
                        trigger: "change",
                    },
                ],
                categoryDesc: [
                    {
                        required: true,
                        message: "请输入类目描述",
                        trigger: "change",
                    },
                ],
            },
            editVisable: false,
            editRules: {
                level: [
                    {
                        required: true,
                        message: "请输入类目级别",
                        trigger: "change",
                    },
                ],
                categoryName: [
                    {
                        required: true,
                        message: "请输入类目名称",
                        trigger: "change",
                    },
                ],
                categoryDesc: [
                    {
                        required: true,
                        message: "请输入类目描述",
                        trigger: "change",
                    },
                ],
            },
            detailVisable: false,
            propertyBindList: [],
            categoryInfo: {},
            addPropertyVisable: false,
            addPropertyForm: {
                propertyId: "",
                isNess: true,
                inputType: "",
                multipleChoice: 1,
            },
            propertyList: [],
            addPropertyRules: {
                propertyId: [
                    {
                        required: true,
                        message: "请选择属性",
                        trigger: "change",
                    },
                ],
                isNess: [
                    {
                        required: true,
                        message: "请选择是否必填",
                        trigger: "change",
                    },
                ],
                multipleChoice: [
                    {
                        required: true,
                        message: "请选择是否可以多选",
                        trigger: "change",
                    },
                ],
            },

            editPropertyForm: {
                id: "",
                propertyId: "",
                isNess: true,
                inputType: "",
                multipleChoice: true,
            },
            editPropertyVisable: false,
            editPropertyRules: {
                propertyId: [
                    {
                        required: true,
                        message: "请选择属性",
                        trigger: "change",
                    },
                ],
                isNess: [
                    {
                        required: true,
                        message: "请选择是否必填",
                        trigger: "change",
                    },
                ],
                multipleChoice: [
                    {
                        required: true,
                        message: "请选择是否可以多选",
                        trigger: "change",
                    },
                ],
            },
        };
    },
    beforeCreate() {},
    created() {
        this.querySearch();
    },
    methods: {
        //查询
        querySearch(type) {
            wmsApi
                .$axiosCategoryTree({})
                .then((res) => {
                    this.listData = res.data.data;
                    // this.total = res.data.data.total;
                    if (this.editCategoryVisible) {
                        this.treedata = [this.listData[this.treeIndex]];
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        addCategoryRoot() {
            this.addCategoryForm = {
                level: 1,
                parentId: 0,
                categoryName: "",
                categoryDesc: "",
                remark: "",
            };
            this.addVisable = true;
        },
        propertyChange1(value) {
            let currentProperty = this.propertyList.filter((item) => {
                return item.id == value;
            });

            this.addPropertyForm.inputType = currentProperty[0].inputType;
            console.log(this.addPropertyForm);
        },
        propertyChange2(value) {
            let currentProperty = this.propertyList.filter((item) => {
                return item.id == value;
            });
            this.editPropertyForm.inputType = currentProperty[0].inputType;
        },
        confirmAdd() {
            this.$refs["addCategoryForm"].validate((valid) => {
                if (valid) {
                    wmsApi
                        .$axiosAddNewCategory(this.addCategoryForm)
                        .then((res) => {
                            if (res.data.errno == 0) {
                                this.$message.success("添加成功");
                                this.addVisable = false;
                                this.querySearch();
                            } else {
                                this.$message.error(res.data.data);
                            }
                        });
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        confirmEdit() {
            this.$refs["editCategoryForm"].validate((valid) => {
                if (valid) {
                    wmsApi
                        .$axiosUpdateCategory(this.editCategoryForm)
                        .then((res) => {
                            if (res.data.errno == 0) {
                                this.$message.success("编辑成功");
                                this.editVisable = false;
                                this.querySearch();
                            } else {
                                this.$message.error(res.data.data);
                            }
                        });
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        editProperty(row) {
            wmsApi
                .$axiosPropertyList({
                    page: 1,
                    size: 100,
                })
                .then((res) => {
                    this.propertyList = res.data.data.list;
                    this.editPropertyForm = {
                        propertyId: row.attributeId,
                        isNess: row.isNess,
                        id: row.bindId,
                        inputType: row.inputType,
                        multipleChoice: row.multipleChoice,
                    };
                    this.editPropertyVisable = true;
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        delCategory(row) {
            this.$confirm("此操作将永久删除, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    wmsApi
                        .$axiosDeleteCategory({
                            categoryId: row.id,
                        })
                        .then((res) => {
                            if (res.data.errno == 0) {
                                this.$message.success("删除成功");
                                this.querySearch();
                            }
                        });
                })
                .catch(() => {});
        },

        shipmentDetail(row, index) {
            console.log(index);
            this.editCategoryTree = "编辑类目 - " + row.categoryName;
            this.editCategoryVisible = true;
            this.treedata = [row];
            this.treeIndex = index;
        },

        remove(node, data) {
            console.log(node);
            console.log(data);
            this.$confirm("此操作将永久删除, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    wmsApi
                        .$axiosDeleteCategory({
                            categoryId: data.id,
                        })
                        .then((res) => {
                            if (res.data.errno == 0) {
                                this.$message.success("删除成功");
                                this.querySearch();
                            }
                        });
                })
                .catch(() => {});
        },
        update(node, data) {
            console.log(data);
            this.editCategoryForm = {
                level: data.level,
                parentId: data.parentId,
                categoryName: data.categoryName,
                categoryDesc: data.categoryDesc,
                remark: data.remark,
                id: data.id,
            };
            this.editVisable = true;
        },
        editCategory(data) {
            this.editCategoryForm = {
                level: data.level,
                parentId: data.parentId,
                categoryName: data.categoryName,
                categoryDesc: data.categoryDesc,
                remark: data.remark,
                id: data.id,
            };
            this.editVisable = true;
        },
        append(data) {
            this.addCategoryForm = {
                level: data.level + 1,
                parentId: data.id,
                categoryName: "",
                categoryDesc: "",
                remark: "",
            };
            this.addVisable = true;
        },
        propertyDetail(row) {
            this.categoryInfo = row;
            wmsApi
                .$axiosPropertyBindRelationByCategoryId({
                    categoryId: row.id,
                })
                .then((res) => {
                    if (res.data.errno == 0) {
                        this.propertyBindList = res.data.data;
                        this.detailVisable = true;
                    }
                });
        },
        addPropertyBind() {
            wmsApi
                .$axiosPropertyList({
                    page: 1,
                    size: 100,
                })
                .then((res) => {
                    this.propertyList = res.data.data.list;
                    this.addPropertyVisable = true;
                    this.addPropertyForm = {
                        propertyId: "",
                        isNess: true,
                        inputType: "",
                        multipleChoice: 1,
                    };
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        confirmAddProperty() {
            this.$refs["addPropertyForm"].validate((valid) => {
                if (valid) {
                    let params = {
                        propertyId: this.addPropertyForm.propertyId,
                        isNess: this.addPropertyForm.isNess,
                        bindType: 1,
                        otherId: this.categoryInfo.id,
                        multipleChoice: this.addPropertyForm.multipleChoice,
                    };
                    wmsApi.$axiosBindProperty(params).then((res) => {
                        if (res.data.errno == 0) {
                            this.$message.success("添加成功");
                            this.propertyDetail(this.categoryInfo);
                            this.addPropertyVisable = false;
                        } else {
                            this.$message.error(res.data.data);
                        }
                    });
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        confirmEditProperty() {
            this.$refs["editPropertyForm"].validate((valid) => {
                if (valid) {
                    let params = {
                        attributeId: this.editPropertyForm.propertyId,
                        isNess: this.editPropertyForm.isNess,
                        bindType: 1,
                        otherId: this.categoryInfo.id,
                        id: this.editPropertyForm.id,
                        multipleChoice: this.editPropertyForm.multipleChoice,
                    };
                    wmsApi.$axiosModifyPropertyBind(params).then((res) => {
                        if (res.data.errno == 0) {
                            this.$message.success("编辑成功");
                            this.propertyDetail(this.categoryInfo);
                            this.editPropertyVisable = false;
                        } else {
                            this.$message.error(res.data.data);
                        }
                    });
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        delProperty(row) {
            this.$confirm("确定删除吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    wmsApi
                        .$axiosDeletePropertyBindRelation({
                            relationId: row.bindId,
                        })
                        .then((res) => {
                            if (res.data.errno == 0) {
                                this.$message.success("删除成功");
                                this.propertyDetail(this.categoryInfo);
                            }
                        });
                })
                .catch(() => {});
        },
    },
};
</script>
<style scoped>
.crumbs {
    margin: 0 0 10px 0;
}
.btn-margin .el-button--small {
    margin: 10px 12px 0 0;
}
>>> .el-image img {
    height: 60px;
    width: 60px;
    margin: 0 12px 12px 0;
    object-fit: cover;
}
.custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
}
</style>
